var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.069,2.505a9.177,9.177,0,0,0-3.122-.488A9.986,9.986,0,0,0,3.314,16.963L2.067,21.04a.751.751,0,0,0,.957.931l3.955-1.335a9.878,9.878,0,0,0,5,1.347h.032a9.985,9.985,0,0,0,3.06-19.478ZM18,17.98A8.426,8.426,0,0,1,12,20.483h-.027a8.376,8.376,0,0,1-4.5-1.3.751.751,0,0,0-.4-.118.733.733,0,0,0-.24.04l-2.9.98.917-3a.749.749,0,0,0-.08-.614A8.484,8.484,0,0,1,11.952,3.517a7.912,7.912,0,0,1,2.653.414A8.487,8.487,0,0,1,18,17.98Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.054,
    cy: 11.984,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.984,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.961,
    cy: 11.984,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech_bubble.7c74015134b53536fc00d0e95b7eb2d8.svg";
export { ForwardRef as ReactComponent };